export const tableData = [
    {
        id:"01",
        name: "Product Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"02",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"03",
        name: "Subcategory Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"04",
        name: "Sales  Menu",
        status: `<i class="fa fa-circle font-danger f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"18",
        name: "Vendor Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"17",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"05",
        name: "Product Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"06",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"07",
        name: "Subcategory Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"08",
        name: "Sales  Menu",
        status: `<i class="fa fa-circle font-danger f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"09",
        name: "Vendor Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"10",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"11",
        name: "Product Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"12",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"13",
        name: "Subcategory Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"14",
        name: "Sales  Menu",
        status: `<i class="fa fa-circle font-danger f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"15",
        name: "Vendor Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"16",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"19",
        name: "Product Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"20",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"21",
        name: "Subcategory Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"22",
        name: "Sales  Menu",
        status: `<i class="fa fa-circle font-danger f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"23",
        name: "Vendor Menu",
        status: `<i class="fa fa-circle font-success f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    },
    {
        id:"24",
        name: "Category Menu",
        status: `<i class="fa fa-circle font-warning f-12" />`,
        companyName: 'Alfreds Futterkiste',
        contact:'Maria Anders',
        country:'Germany',
        create_on:"2022-04-18T00:00:00"
    }
]